import { render } from "./PunchKingWinners.vue?vue&type=template&id=7af8b4c2"
import script from "./PunchKingWinners.vue?vue&type=script&lang=js"
export * from "./PunchKingWinners.vue?vue&type=script&lang=js"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__